import { Component, input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { DgxIconName } from '../icon/models/icon-name.type';

@Component({
  selector: 'app-description-list-item',
  templateUrl: './description-list-item.component.html',
  styleUrls: ['./description-list-item.component.scss'],
  imports: [IconComponent],
})
export class DescriptionListItemComponent {
  data = input<string>();
  dataAsList = input<boolean>(false);
  leftIcon = input<DgxIconName>();
  rightIcon = input<DgxIconName>();
  title = input<string>();
}
